export default __webpack_public_path__ + "quicksuite-logo-default.b09eadde.svg";